<template>
  <v-container>
    <v-card>
      <component v-bind:is="'Cookies' + activeLocale.toUpperCase()" />
    </v-card>
  </v-container>
</template>

<script>
import CookiesCS from '../components/Cookies/Cookies-cs';
import CookiesEN from '../components/Cookies/Cookies-en';
import CookiesPL from '../components/Cookies/Cookies-pl';
import CookiesDE from '../components/Cookies/Cookies-de';
export default {
  name: 'CookiePolicy',
  components: {
    CookiesCS,
    CookiesEN,
    CookiesDE,
    CookiesPL
  },
  data() {
    return {
      activeLocale: 'cs'
    }
  },
  mounted() {
    this.activeLocale = this.$i18n.locale;
  },
  watch: {
    "$i18n.locale": function (val) {
      this.activeLocale = val;
    },
  }
}
</script>
